import { OnChanges, OnDestroy, Renderer2, SimpleChanges, } from '@angular/core';
import { first } from 'rxjs/operators';
import { IconService } from './icon.service';
export var IconColor;
(function (IconColor) {
    IconColor["DARK"] = "dark";
    IconColor["INHERIT"] = "inherit";
    IconColor["LIGHT"] = "light";
    IconColor["MID"] = "mid";
    IconColor["PRIMARY"] = "primary";
    IconColor["WHITE"] = "white";
})(IconColor || (IconColor = {}));
export var HoverColor;
(function (HoverColor) {
    HoverColor["CURRENT"] = "currentColor";
    HoverColor["LIGHT"] = "light";
    HoverColor["PRIMARY"] = "primary";
})(HoverColor || (HoverColor = {}));
export var IconSize;
(function (IconSize) {
    IconSize["MID"] = "mid";
    IconSize["SMALL"] = "small";
})(IconSize || (IconSize = {}));
export var IconBackdrop;
(function (IconBackdrop) {
    IconBackdrop["FREEMARKET"] = "freemarket";
    IconBackdrop["PRIMARY"] = "primary";
    IconBackdrop["PRIMARY_DARK"] = "primary-dark";
    IconBackdrop["TERTIARY"] = "tertiary";
    IconBackdrop["TRANSPARENT"] = "transparent";
    IconBackdrop["WARRIOR_FORUM"] = "warrior-forum";
})(IconBackdrop || (IconBackdrop = {}));
var IconComponent = /** @class */ (function () {
    function IconComponent(renderer, iconService, uiConfig) {
        this.renderer = renderer;
        this.iconService = iconService;
        this.uiConfig = uiConfig;
        this.color = IconColor.DARK;
        this.size = IconSize.MID;
        this.backdrop = undefined;
    }
    Object.defineProperty(IconComponent.prototype, "legacy", {
        set: function (value) {
            this.attrLegacy = value ? true : undefined;
        },
        enumerable: true,
        configurable: true
    });
    IconComponent.prototype.setElement = function (svg) {
        var _this = this;
        var layoutElement = this.container.nativeElement;
        // Detach all views of the child nodes of the root element.
        // NOTE: This wouldn't work in IE 11 because there's a bug there that
        // causes SVG to not be included in the list.
        // We've polyfilled it though.
        // Ref: https://github.com/angular/angular/issues/6327
        Array.from(layoutElement.childNodes).forEach(function (node) {
            _this.renderer.removeChild(layoutElement, node);
        });
        // Put the new icon SVG in.
        this.renderer.appendChild(layoutElement, svg);
    };
    IconComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        var changedInputs = Object.keys(changes);
        if (changedInputs.includes('name')) {
            // Check if the new value is not an empty string or undefined.
            if (changes.name.currentValue) {
                this.iconSubscription = this.iconService
                    .getIcon(this.uiConfig.assetsBaseUrl + "/icons/" + changes.name.currentValue + ".svg", this.renderer)
                    .pipe(first())
                    .subscribe(function (svg) {
                    _this.setElement(svg);
                });
            }
        }
        if (changedInputs.includes('label')) {
            this.attrAriaHidden = changes.name.currentValue ? undefined : true;
        }
    };
    IconComponent.prototype.ngOnDestroy = function () {
        if (this.iconSubscription !== undefined) {
            this.iconSubscription.unsubscribe();
        }
    };
    return IconComponent;
}());
export { IconComponent };



// WEBPACK FOOTER //
// ./src/app/@shared/ui/icon/icon.component.ts.pre-build-optimizer.js